import search from './search';

const storeData = {
  modules: {
    search
  }
};

export let store = {};
const createStore = Vuex => {
  store = new Vuex.Store(storeData);
  return store;
};

export default createStore;
